<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_personal-asset-wallet.text1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-wallet.text2') }}<br />
					{{ $t('rtr_personal-asset-wallet.text3') }}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>

		<div class="bottom_area">
			<div class="bottom_box">
				<h2 class="headline_s type2 mb_16">
					{{ $t('rtr_personal-asset-wallet.text4') }}<br />
					{{ $t('rtr_personal-asset-wallet.text5') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-asset-wallet.text6') }}<br />
					{{ $t('rtr_personal-asset-wallet.text7') }}
				</p>
			</div>
			<div class="catch_box">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_personal-asset-wallet.text8') }}<br />
					{{ $t('rtr_personal-asset-wallet.text9') }}
				</p>
				<p class="body_m fc_white">
					{{ $t('rtr_personal-asset-wallet.text10') }}<br />
					{{ $t('rtr_personal-asset-wallet.text11') }}
				</p>
			</div>
			<div class="bottom_box_2">
				<p class="title_m mb_16">
					{{ $t('rtr_personal-asset-wallet.text12') }}<br />
					{{ $t('rtr_personal-asset-wallet.text13') }}
				</p>
				<p class="body_m">
					{{ $t('rtr_personal-asset-wallet.text14') }}<br />
					{{ $t('rtr_personal-asset-wallet.text15') }}<br />
					{{ $t('rtr_personal-asset-wallet.text16') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Wallet.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
